import styled from 'styled-components';
import { srOnly } from '@/app/components/search/styles/mixins.ts';

const Region = styled.div`
  ${srOnly};
`;

// Keep it mounted and change only the text: a region inserted together with its text is often not announced.
export const StatusMessage = ({ message }: { message: string }) => (
  <Region role="status" aria-live="polite" aria-atomic="true">
    {message}
  </Region>
);
